import { gql } from "@apollo/client";

export const ACCEPT_OPT_IN = gql`
  mutation ApproveInitiativeOptin($optinId: String!, $organizationId: String!) {
    approveInitiativeOptin(optinId: $optinId, organizationId: $organizationId) {
      id
      organizationId
      status
      initiativeId
    }
  }
`;
